import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: themes.light.white[1],
    gap: 6,
    borderRadius: 16,
    paddingVertical: 12,
    paddingHorizontal: 16,
    shadowColor: themes.light.gray[1],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  logo: {
    width: 80,
    height: 45,
    resizeMode: 'contain',
  },
  premiumText: {},
  coveragesText: {
    color: themes.light.gray[6],
  },
});
